// extracted by mini-css-extract-plugin
module.exports = {"pre":"Pre_pre___5JBf"};